import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ContractArchiveModal = ({ isOpen, onClose, contractTypeConfig, onSelectContract }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedContract, setSelectedContract] = useState(null);

  if (!isOpen) return null;

  // Mock archived contracts - in production, fetch from database
  const archivedContracts = [
    {
      id: 'ARC-001',
      contractNumber: 'CNT-2025-156',
      propertyTitle: 'شقة فاخرة في دبي مارينا',
      clientName: 'محمد عبدالله السعيد',
      contractType: contractTypeConfig?.type?.label,
      date: '15/12/2025',
      status: 'مكتمل',
      price: '250,000 دينار',
      duration: 'سنة واحدة'
    },
    {
      id: 'ARC-002',
      contractNumber: 'CNT-2025-142',
      propertyTitle: 'فيلا مستقلة في الريم',
      clientName: 'فاطمة خالد المنصوري',
      contractType: contractTypeConfig?.type?.label,
      date: '08/12/2025',
      status: 'مكتمل',
      price: '450,000 دينار',
      duration: 'سنتان'
    },
    {
      id: 'ARC-003',
      contractNumber: 'CNT-2025-128',
      propertyTitle: 'مكتب تجاري في الخليج التجاري',
      clientName: 'شركة الابتكار للتقنية',
      contractType: contractTypeConfig?.type?.label,
      date: '01/12/2025',
      status: 'مكتمل',
      price: '180,000 دينار',
      duration: 'ثلاث سنوات'
    }
  ];

  const filteredContracts = archivedContracts?.filter(contract =>
    contract?.propertyTitle?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    contract?.clientName?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    contract?.contractNumber?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const handleSelectContract = () => {
    if (!selectedContract) {
      alert('الرجاء اختيار عقد من الأرشيف');
      return;
    }
    onSelectContract(selectedContract);
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10006]" onClick={onClose} />
      <div 
        className="fixed z-[10007] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-4xl mx-4 max-h-[90vh] overflow-hidden flex flex-col"
        style={{
          borderColor: contractTypeConfig?.type?.color || '#8B5CF6',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <div className="p-6 border-b border-gray-700" dir="rtl">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div 
                className="p-3 rounded-lg"
                style={{ backgroundColor: `${contractTypeConfig?.type?.color}20` }}
              >
                <Icon name="Archive" size={28} color={contractTypeConfig?.type?.color} />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">أرشيف العقود</h3>
                <p className="text-sm text-gray-400">اختر عقد من الأرشيف - {contractTypeConfig?.type?.label}</p>
              </div>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          {/* Search Bar */}
          <div className="relative">
            <Icon name="Search" size={18} color="#9CA3AF" className="absolute right-3 top-1/2 -translate-y-1/2" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              placeholder="ابحث عن عقد (رقم العقد، العقار، العميل...)"
              className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 pr-10 text-white text-right placeholder:text-gray-500"
              dir="rtl"
            />
          </div>
        </div>

        {/* Contracts List */}
        <div className="flex-1 overflow-y-auto p-6" dir="rtl">
          {filteredContracts?.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <div className="p-4 bg-gray-800/50 rounded-full mb-4">
                <Icon name="FileX" size={48} color="#9CA3AF" />
              </div>
              <p className="text-gray-400 text-lg">لا توجد عقود في الأرشيف</p>
              <p className="text-gray-500 text-sm mt-2">جرب البحث بكلمات مختلفة</p>
            </div>
          ) : (
            <div className="space-y-3">
              {filteredContracts?.map((contract) => (
                <div
                  key={contract?.id}
                  onClick={() => setSelectedContract(contract)}
                  className={`p-4 rounded-xl border-2 cursor-pointer transition-all hover:scale-[1.02] ${
                    selectedContract?.id === contract?.id
                      ? 'border-purple-500 bg-purple-600/20' :'border-gray-700 bg-gray-800/50 hover:border-gray-600'
                  }`}
                >
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <h5 className="text-white font-bold text-lg">{contract?.propertyTitle}</h5>
                        {selectedContract?.id === contract?.id && (
                          <Icon name="CheckCircle" size={20} color="#8B5CF6" />
                        )}
                      </div>
                      <div className="grid grid-cols-2 gap-2 text-sm">
                        <div className="flex items-center gap-2">
                          <Icon name="Hash" size={14} color="#9CA3AF" />
                          <span className="text-gray-400">رقم العقد:</span>
                          <span className="text-white font-medium">{contract?.contractNumber}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Icon name="User" size={14} color="#9CA3AF" />
                          <span className="text-gray-400">العميل:</span>
                          <span className="text-white font-medium">{contract?.clientName}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Icon name="Calendar" size={14} color="#9CA3AF" />
                          <span className="text-gray-400">التاريخ:</span>
                          <span className="text-white font-medium">{contract?.date}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Icon name="Clock" size={14} color="#9CA3AF" />
                          <span className="text-gray-400">المدة:</span>
                          <span className="text-white font-medium">{contract?.duration}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Icon name="DollarSign" size={14} color="#9CA3AF" />
                          <span className="text-gray-400">القيمة:</span>
                          <span className="text-white font-medium">{contract?.price}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="px-2 py-1 rounded-lg bg-green-600/20 border border-green-500/30 text-green-300 text-xs font-medium">
                            {contract?.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer Actions */}
        <div className="p-6 border-t border-gray-700" dir="rtl">
          <div className="flex gap-3">
            <button
              onClick={handleSelectContract}
              disabled={!selectedContract}
              className="flex-1 py-3 rounded-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Icon name="Check" size={18} color="#FFF" />
              استخدام العقد المحدد
            </button>
            <button
              onClick={onClose}
              className="flex-1 py-3 rounded-lg font-semibold text-white bg-gray-700 hover:bg-gray-600 transition-colors"
            >
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContractArchiveModal;